import Flag from './Flag.vue'

export default Flag



// WEBPACK FOOTER //
// ./src/app/components/common/flag/index.js